import CustomerInsightsService from '@/apps/customer-insigths/services/customer_insights_service';
export default {
  getInitialData: function getInitialData(context) {
    var tags_somos1 = ['Insights', 'Visitas', 'Métricas', 'Zonal', 'Interzonal'];
    var tags_organizations = [];
    CustomerInsightsService.getInitialData().then(function (response) {
      context.commit('setRegions', response.data.regions);
      context.commit('setSections', response.data.sections);
      // context.commit('setUsers', response.data.users)
      context.commit('setTags', tags_somos1);
      context.commit('setTagsOrg', tags_organizations);
      context.commit('setUpdateHours', response.data.update_hours);
    });
  },
  getUpdateHours: function getUpdateHours(context) {
    CustomerInsightsService.getUpdateHours().then(function (response) {
      context.commit('setUpdateHours', response.data);
    });
  }
};